import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'

import JobsTable from './JobTable'
import UserListTable from './UsersListTable'
import { API_URL } from '..'

export default function UsersPage() {
  const [jobsData , setJobData] = useState([])
  const fetchJobs = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       
       let response = await fetch(API_URL+"/api/user/all", { 
         method: "GET",
         headers: headersList
       });
       
       let data = await response.json();
       
      setJobData(data)
}
useEffect(()=>{
  fetchJobs()
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Users" />

        {/* TableDataLayer */}
        {
          jobsData.length == 0 ? null : 
          <UserListTable jobsData={jobsData.reverse()}/>

        }

        </MasterLayout>
    </>
  )
}
